PegasusTemplate.BlockOperationsController = Ember.ObjectController.extend({
  actions: {
    editBlock: function(){
      this.showOperations();
      if ( this.get('content') ) {
        PegasusTemplate.stateMachine.send( 'edit', this.get('content') );
      }
    },
    didFinishViewing: function(){
      PegasusTemplate.stateMachine.send('didFinishViewing');
    },
  },

  needs: ['canvas', 'viewOptions'],

  zoomValue: function(){
    return this.get('controllers.viewOptions.zoomValue');
  }.property('controllers.viewOptions.zoomValue'),

  effectiveOperations: function(){
    if( !this.get('content') ){ return []; }
    return this.get('operations').filter( function(op){
      return this.get('only').map(function(boundOperation){
        return boundOperation.underscore();
      }).contains( op.get('name').underscore() );
    }, this);
  }.property( 'content.elementId' ),

  isOperable: function(){
    return !!( this.get('effectiveOperations.length') );
  }.property('effectiveOperations.length'),

  showOperations: function(){
    PegasusTemplate.stateMachine.send( 'viewOperations', { view: this.get('content') });
  },

  droppableTimer: null,

  operations: [
    Ember.Object.create({
      name: 'MoveUp',
      action: function(){
        PegasusTemplate.stateMachine.send( 'moveUp' );
      }
    }),
    Ember.Object.create({
      name: 'MoveDown',
      action: function(){
        PegasusTemplate.stateMachine.send( 'moveDown' );
      }
    }),
    Ember.Object.create({
      name: 'Upload',
      action: function(){
        PegasusTemplate.stateMachine.send( 'upload' );
      }
    }),
    Ember.Object.create({
      name: 'Edit',
      action: function(){
        PegasusTemplate.stateMachine.send( 'edit', this );
      }
    }),
    Ember.Object.create({
      name: 'Copy',
      action: function(){
        PegasusTemplate.stateMachine.send( 'copy' );
      }
    }),
    Ember.Object.create({
      name: 'Delete',
      action: function(){
        PegasusTemplate.stateMachine.send( 'deleteBlock' );
      }
    })
  ]
});
